// src/components/gestionEvento/Ajustes/Competidores/Inscripciones/MemberRow.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  TableRow,
  TableCell,
  Tooltip,
  Checkbox,
  Box,
  Avatar,
  Typography,
  Chip,
} from '@mui/material';

// Helper para no renderizar objetos como children
const toText = (v, fallback = '—') => {
  if (v === null || v === undefined) return fallback;
  if (typeof v === 'string' || typeof v === 'number') return String(v);
  if (typeof v === 'object') return v.nombre ?? v.name ?? v.label ?? fallback;
  return String(v ?? fallback);
};

const formatPago = (pago) => {
  if (!pago) return '—';
  if (pago === 'enLinea') return 'En línea';
  if (pago === 'diaEvento') return 'Efectivo';
  return String(pago);
};

const StatusChip = ({ status }) => {
  const map = {
    Pagado:     { color: 'success', label: 'Pagado' },
    EnProgreso: { color: 'primary', label: 'En Progreso' },
    Pendiente:  { color: 'warning', label: 'Pendiente' },
    Rechazado:  { color: 'error',   label: 'Rechazado' },
  };
  const cfg = map[status] || map.Pendiente;
  return <Chip label={cfg.label} color={cfg.color} size="small" />;
};
StatusChip.propTypes = { status: PropTypes.string };

function MemberRow({
  row,
  selected,
  onSelectChange,
  openDetails,
}) {
  const equipoObj = typeof row.equipo === 'object' ? row.equipo : null;
  const categoriaNombre =
    typeof row.categoria === 'object' ? row.categoria?.nombre : row.categoria;

  const payment = row.paymentMethod || row.pago;
  const computedStatus = row.status
    ? row.status
    : payment === 'enLinea'
    ? 'Pagado'
    : payment === 'diaEvento'
    ? 'Pendiente'
    : 'Pendiente';

  return (
    <TableRow
      hover
      sx={{ cursor: 'pointer' }}
      onClick={(e) => {
        const tag = (e.target.tagName || '').toLowerCase();
        if (['input', 'button', 'svg', 'path'].includes(tag)) return;
        openDetails?.(row);
      }}
    >
      {/* Selección */}
      <TableCell padding="checkbox">
        <Tooltip title="Seleccionar">
          <Checkbox
            checked={!!selected}
            onChange={(e) => onSelectChange?.(row.id, e.target.checked)}
            onClick={(e) => e.stopPropagation()}
          />
        </Tooltip>
      </TableCell>

      {/* # Registro */}
      <TableCell sx={{ width: { xs: 96, sm: 110, md: 120 } }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {toText(row.codigoId)}
        </Typography>
      </TableCell>

      {/* Nombre */}
      <TableCell sx={{ fontWeight: 700 }}>
        {`${toText(row.nombre, '')} ${toText(row.apellido, '')}`.trim() || '—'}
      </TableCell>

      {/* Rama */}
      <TableCell>{toText(row.rama)}</TableCell>

      {/* Categoría */}
      <TableCell>{toText(categoriaNombre)}</TableCell>

      {/* Equipo */}
      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar
            src={equipoObj?.logoEquipo || ''}
            alt={toText(equipoObj?.name || row.equipo, '')}
            variant="square"
            sx={{ width: 24, height: 24 }}
          />
          <Typography variant="body2">
            {equipoObj ? toText(equipoObj.name) : toText(row.equipo)}
          </Typography>
        </Box>
      </TableCell>

      {/* Status */}
      <TableCell>
        <StatusChip status={toText(computedStatus, 'Pendiente')} />
      </TableCell>

      {/* Pago */}
      <TableCell>
        <Typography variant="body2">{formatPago(payment)}</Typography>
      </TableCell>
    </TableRow>
  );
}

MemberRow.propTypes = {
  row: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelectChange: PropTypes.func,
  openDetails: PropTypes.func,
};

export default MemberRow;
